module.exports = __webpack_public_path__ + "media/components/country-flag/static/gb-sct-b4a7dcb957fa46cf7ffffdc0652ad434.svg";